module.exports = __webpack_public_path__ + "static/media/topic04.c1e313bf.jpg";